import {
  createContext,
  useContext,
  useEffect,
  useState,
  useCallback
} from 'react'
import { useTime } from './use-time'
import { useAnimate } from './use-animate'
const WorldContext = createContext({
  frame: {},
  sprites: {},
  addSprite: () => true
})
export const WorldProvider = ({ children }) => {
  const [container, setContainer] = useState({ width: 300, height: 200 })
  const [dialog, setDialog] = useState([])
  const [frame, updateWorld] = useState()
  const [offset, setOffset] = useState({ x: 0, y: 0 })
  const [pause, setPause] = useState(false)
  const [time, setTime] = useTime()
  const [sprites, setSprites] = useState({})
  const [target, setTarget] = useState()
  const addSprite = (position) => {
    setSprites((sprites) => {
      return { ...sprites, [position.id]: { position } }
    })
  }
  const removeSprite = ({ id }) => {
    setSprites((sprites) => {
      delete sprites[id]
      return { ...sprites }
    })
  }
  const animateCallback = useCallback((next) => {
    updateWorld(next)
  }, [])
  useAnimate(animateCallback)
  useEffect(() => {
    if (pause) return
    const timer = setInterval(() => setTime(), 1000)
    return () => clearInterval(timer)
  }, [pause, setTime])
  return (
    <WorldContext.Provider
      value={{
        addSprite,
        container,
        dialog,
        frame,
        offset,
        removeSprite,
        setContainer,
        setDialog,
        setOffset,
        sprites,
        time,
        target,
        setTarget
      }}
    >
      {children}
    </WorldContext.Provider>
  )
}
export const useWorld = () => useContext(WorldContext)
